<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    (onHide)="close()"
    [width]="isJa ? '8rem':'7rem'">
    <n-header class="flex-wrapper">
        <h1>{{upgradeMode === UpgradeModeE.System ? this.i18n.systemUpgradeTitle : this.i18n.hotPatchTitle}}</h1>
        <n-help-link key="storagesysUpgrade" *ngIf="!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifyInfo" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>
    <!-- 步骤条 -->
    <n-steps
        id="upgrade-upload-entry-steps"
        *ngIf="upgradeMode === UpgradeModeE.System"
        [model]="steps"
        [activeIndex]="activeIndex"
        styleClass="steps-custom mt-30">
    </n-steps>
    <!-- 热补丁 -->
    <app-upgrade-upload #upgradeEl
        *ngIf="upgradeMode === UpgradeModeE.HotPatch"
        [upgrade]="upgrade"
        [currentVersion]="currentVersion">
    </app-upgrade-upload>
    <!-- 系统升级 -->
    <app-system-upgrade-upload #systemUpgradeEl
        *ngIf="upgradeMode === UpgradeModeE.System"
        [upgrade]="systemUpgrade"
        [currentVersion]="currentVersion"
        [activeIndex]="activeIndex">
    </app-system-upgrade-upload>
    <n-footer>
        <div class="slide-button-group interval-20">
            <!-- 上一步 -->
            <button nButton
                *ngIf="upgradeMode === UpgradeModeE.System && activeIndex !== 0"
                id="create_hyper_metro_cgroup_previous_btn"
                [label]="i18n.previousBtn"
                [disabled]="prevBtnDisabled | fn :systemUpgradeEl?.currentProcess :systemUpgradeEl?.backupLoading"
                (click)="previous()">
            </button>
            <!-- 下一步 -->
            <button nButton
                *ngIf="upgradeMode === UpgradeModeE.System && activeIndex !== steps.length - 1"
                theme="primary"
                id="create_hyper_metro_cgroup_next_btn"
                [label]="i18n.nextBtn"
                [disabled]="nextBtnDisabled | fn :activeIndex :systemUpgradeEl?.currentProcess :systemUpgradeEl?.isShowExport :systemUpgradeEl?.isExportSucceed :systemUpgradeEl?.backupLoading"
                [disabledTips]="nextBtnDisabledTips | fn: activeIndex"
                (click)="next()">
            </button>
            <button nButton
                *ngIf="upgradeMode === UpgradeModeE.HotPatch || activeIndex === steps.length - 1"
                theme="primary"
                (click)="onUpgrade()"
                [disabled]="upgradeBtnDisabled | fn :upgradeEl :systemUpgradeEl :upgradeEl?.upgradeBtnDisabled :systemUpgradeEl?.upgradeBtnDisabled"
                [disabledTips]="upgradeBtnDisabledTips | fn: systemUpgradeEl?.hotpatchUploadEnable"
                [label]="i18n.upgradeBtn">
            </button>
            <button nButton
                (click)="close()"
                [label]="i18n.cancelBtn">
            </button>
        </div>
    </n-footer>

    <ng-template #upgradePrompt>
        <n-data-table id="upgrade_prompt_table"
            style="height: 1.5rem;"
            [columnDefs]="upgradePromptColumnDefs"
            [config]="upgradePromptConfig"
            [data]="upgradePromptData">
        </n-data-table>
    </ng-template>
</n-slide-window>
